/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Collapse as AntdCollapse } from 'antd';
import clsx from 'clsx';

import { ReactComponent as ArrowIcon } from '@assets/icons/arrow.svg';

import Typography from '../Typography';

import s from './styles.module.less';

const ExpandIcon = (props) => (
  <span role="img" aria-label="right">
    <ArrowIcon
      focusable={false}
      fill="currentColor"
      aria-hidden
      style={!props.isActive ? { transform: 'rotate(90deg)' } : null}
    />
  </span>
);

const Collapse = ({ className, ...props }) => (
  <AntdCollapse className={clsx(className, s.custom)} expandIcon={ExpandIcon} expandIconPosition="right" {...props} />
);

const BasePanel = ({ className, ...props }) => <AntdCollapse.Panel className={clsx(className, s.custom)} {...props} />;

const Panel = ({ header, note, ...props }) => (
  <BasePanel
    {...props}
    header={
      <>
        <Typography.Title level={3} style={{ marginBottom: 0 }} note={note}>
          {header}
        </Typography.Title>
      </>
    }
  />
);

Collapse.BasePanel = BasePanel;
Collapse.Panel = Panel;

export default Collapse;
